import React from 'react'
import { useTranslation } from "react-i18next"
import { useTheme } from "react-jss"
import textLinksStyle from './text-links-style'

const documentRootURL = '/files/'

const DATA_LINKS = [
  { key: 'cgu', labelTrad: 'account.doc_cgu', url: 'https://www.wifirst.com/terms-of-use-all-versions'},
  {
    key: 'cgv', labelTrad: 'account.doc_cgv',
                url: { en: 'https://assets.wifirst.net/cgv/cgv_en.pdf', fr: 'https://assets.wifirst.net/cgv/cgv_fr.pdf'}
    },
  { key: 'resil', labelTrad: 'account.doc_resil', url: documentRootURL + 'formulaire_resil.pdf'},
  { key: 'cont', labelTrad: 'account.doc_cont', url: documentRootURL + 'formulaire_cont.pdf'},
  { key: 'dedo', labelTrad: 'account.doc_dedo', url: documentRootURL + 'formulaire_dedo.pdf'},
  { key: 'retract', labelTrad: 'account.doc_retract', url: documentRootURL + 'formulaire_retract.pdf'},
  { key: 'faq', labelTrad: 'account.doc_faq', url: 'https://support.wifirst.net/fr/support/home'},
]

function getUrl(url, locale) {
  if (typeof url === "string") {
    return url
  }

  // Let's suppose that french will always be present
  return url[locale] || url.en
}

export default function TextLinks() {
  const { t, i18n } = useTranslation()
  const theme = useTheme()
  const classes = textLinksStyle(theme)

  return <>
    {DATA_LINKS.map(link =>
      <a key={link.key} className={classes.linkItem} href={getUrl(link.url, i18n.language)} target='_blank'>
        <span>{t(link.labelTrad)}</span>
      </a>
    )}
  </>
}
